(function () {
'use strict';

angular
.module('app.performanceReportMentionTimeline')
.controller('performanceReportMentionTimelineCtrl', 
    ['$scope', '$rootScope', 'measureService', 'performanceReportMentionTimelineService','$http', '$controller',
    function ($scope, $rootScope, measureService, performanceReportMentionTimelineService, $http, $controller){

        $scope.activityMentionTimeLineChart  = {
          options: {
            chart: {
              type: 'column',
              zoomType: 'x',
              marginTop: 70
            },
            plotOptions: {
              column: {
                maxPointWidth: 25,
                stacking: 'normal',
                dataLabels: {
                  enabled: false
                }
              },
              marker: {
                enabled: false
              },
              series: {
                  events: {
                      legendItemClick: function (event) {
                        event= event|| window.event;
                          var visibility = this.visible ? 'visible' : 'hidden';
                          if (visibility == 'visible'){
                              event.target.legendGroup.div.childNodes[0].childNodes[2].classList.add('exposure-report-activity-timeline-chart-legend-title-show');
                              event.target.legendGroup.div.childNodes[0].childNodes[1].classList.add('exposure-activity-timeline-chart-legend-symbol-hide');
                          } else{
                              event.target.legendGroup.div.childNodes[0].childNodes[2].classList.remove('exposure-report-activity-timeline-chart-legend-title-show');
                              event.target.legendGroup.div.childNodes[0].childNodes[1].classList.remove('exposure-activity-timeline-chart-legend-symbol-hide');
                          }
                      }
                  }
              }
            },
            legend: {
              itemDistance: 25,
              verticalAlign: 'top',
              align: 'right',
              x: -10,
              useHTML: true,
              labelFormatter: function () {
                return '<div class="custom_legend_background"></div><div class="custom_legend_symbol custom_legend_symbol_' + this.name + '" style="background-color:' + this.color + '"></div><div class="custom_legend_title">' + this.name + '</div>' + this.name;
              }
            },
            tooltip: {
                useHTML: true,
                followPointer: false,
                backgroundColor: "#333b48",
                pointFormatter: function () {
                    return '<b>' + Highcharts.numberFormat(this.y, 0, 0, ',') + '</b>';
                },
                headerFormat: "",
                borderRadius: 24,
                borderWidth: 0,
                shadow: false,
                shape: "callout",
                style: {
                  "color": "#FFFFFF",
                  "padding": "6"
                }
              }
          },
          series: [],
          title: {
              text: 'Mention Timeline',
              align: 'left',
              y: 15,
              useHTML: true,
              style: {
                fontFamily: "ProximaNovaSemibold",
                fontSize: "16px",
                color: "#4B5567",
                textTransform: "uppercase"
              }
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e %b'
            },            
            labels: {
                y: 40,
                useHTML: true,
                style: {
                    textTransform: "uppercase",
                    fontFamily: "ProximaNovaSemibold",
                    fontSize: "12px"
                }
            },
            tickLength: 0
          },
          yAxis: {
              title: {
                  text: null
              },
              labels: {
                useHTML: true,
                style: {
                    textTransform: "uppercase",
                    fontFamily: "ProximaNovaSemibold",
                    fontSize: "12px"
                },
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0, 0, ',');
                }
            }
          },
          noData: 'Pending Data...',
          loading: true
        };

        $scope.activityMentionTimeLineChartForPrint  = {
          options: {
            chart: {
              type: 'column',
              zoomType: 'x',
              marginTop: 70
            },
            plotOptions: {
              column: {
                maxPointWidth: 25,
                stacking: 'normal',
                dataLabels: {
                  enabled: false
                }
              },
              marker: {
                enabled: false
              },
              series: {
                  events: {
                      legendItemClick: function (event) {
                        event= event|| window.event;
                          var visibility = this.visible ? 'visible' : 'hidden';
                          if (visibility == 'visible'){
                              event.target.legendGroup.div.childNodes[0].childNodes[2].classList.add('exposure-report-activity-timeline-chart-legend-title-show');
                              event.target.legendGroup.div.childNodes[0].childNodes[1].classList.add('exposure-activity-timeline-chart-legend-symbol-hide');
                          } else{
                              event.target.legendGroup.div.childNodes[0].childNodes[2].classList.remove('exposure-report-activity-timeline-chart-legend-title-show');
                              event.target.legendGroup.div.childNodes[0].childNodes[1].classList.remove('exposure-activity-timeline-chart-legend-symbol-hide');
                          }
                      }
                  }
              }
            },
            legend: {
              itemDistance: 25,
              verticalAlign: 'top',
              align: 'right',
              x: -10,
              useHTML: true,
              labelFormatter: function () {
                return '<div class="custom_legend_background"></div><div class="custom_legend_symbol custom_legend_symbol_' + this.name + '" style="background-color:' + this.color + '"></div><div class="custom_legend_title">' + this.name + '</div>' + this.name;
              }
            },
            tooltip: {
                useHTML: true,
                followPointer: false,
                backgroundColor: "#333b48",
                pointFormatter: function () {
                    return '<b>' + Highcharts.numberFormat(this.y, 0, 0, ',') + '</b>';
                },
                headerFormat: "",
                borderRadius: 24,
                borderWidth: 0,
                shadow: false,
                shape: "callout",
                style: {
                  "color": "#FFFFFF",
                  "padding": "6"
                }
              }
          },
          series: [],
          title: {
              text: 'Mention Timeline',
              align: 'left',
              y: 15,
              useHTML: true,
              style: {
                fontFamily: "ProximaNovaSemibold",
                fontSize: "28px",
                color: "#4B5567",
                textTransform: "uppercase"
              }
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e %b'
            },            
            labels: {
                y: 40,
                useHTML: true,
                style: {
                    textTransform: "uppercase",
                    fontFamily: "ProximaNovaSemibold",
                    fontSize: "20px"
                }
            },
            tickLength: 0,
            tickPixelInterval: 160
          },
          yAxis: {
              title: {
                  text: null
              },
              labels: {
                useHTML: true,
                style: {
                    textTransform: "uppercase",
                    fontFamily: "ProximaNovaSemibold",
                    fontSize: "20px"
                },
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0, 0, ',');
                }
            }
          },
          noData: 'Pending Data...',
          loading: true
        };
       
        //Watch on change keyword / blog / project change
        $scope.$on('refreshDashboard', function(event, args) {
            getDataPerformanceReportMentionTimelineChart();
        });

        function getDataPerformanceReportMentionTimelineChart() {
            var params = $rootScope.saveParams;
            if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
              return;
            } 
            params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

            getMentionTimelineData(params);
        }

        function getMentionTimelineData(params){
          $scope.activityMentionTimeLineChart.loading = true;
          $scope.activityMentionTimeLineChartForPrint.loading = true;
          performanceReportMentionTimelineService.getMentionTimelineData(params)
              .then(function(response){
                  genMentionTimeline(response.data.data);
              })
              .catch(function(message){
                $scope.activityMentionTimeLineChart.series = [];
                $scope.activityMentionTimeLineChartForPrint.series = [];
              })
              .finally(function(){
                $scope.activityMentionTimeLineChart.loading = false;   
                $scope.activityMentionTimeLineChartForPrint.loading = false;    
                $rootScope.$broadcast('sectionLoaded');
              })          
        }

        function genMentionTimeline(data){
          var keyword = {name: 'KEYWORDS', data: [], color: '#55E9A9'};
          var urls = {name: 'URLS', data: [], color: '#0277BD'};
          var hashTags = {name: 'HASHTAGS', data: [], color: '#03A9F4'};

          if(data != null && data.length > 0){
            angular.forEach(data, function (item) {
              if(item.keyword_type == "Keyword"){
                keyword.data.push([item.date, item.appear]);
              }
              if(item.keyword_type == "Url"){
                urls.data.push([item.date, item.appear]);
              }
              if(item.keyword_type == "Hashtag"){
                hashTags.data.push([item.date, item.appear]);
              }
            });
          }

          $scope.activityMentionTimeLineChart.series = [];
          $scope.activityMentionTimeLineChart.series.push(keyword);
          $scope.activityMentionTimeLineChart.series.push(urls);
          $scope.activityMentionTimeLineChart.series.push(hashTags);
          

          //chart for print
          $scope.activityMentionTimeLineChartForPrint.series = [];
          $scope.activityMentionTimeLineChartForPrint.series.push(keyword);
          $scope.activityMentionTimeLineChartForPrint.series.push(urls);
          $scope.activityMentionTimeLineChartForPrint.series.push(hashTags);
        }

        // first initiating
        getDataPerformanceReportMentionTimelineChart();
    }]);
})();